import isNumeric from 'validator/es/lib/isNumeric';
import isUUID from 'validator/es/lib/isUUID';
import { clientError, invalidUrlCharacters } from '@/utils/errors';
import fields, { globalFieldLengths } from '@/constants/fields';
import urlDenyCharacters from '@/constants/validation';
import findResult, { assignProps, hasMinimumLength } from '@/utils/resultsHelper';
import { splitUrlArguments } from '@/constants/urls';
import { destroyStates } from '@/constants/lifecycle';
import { findAllUserGroups } from './state/state';

export const validateUserGroupCode = (userGroup, intl) => {
  if (
    userGroup.code
    && (isNumeric(userGroup.code)
      || invalidUrlCharacters(userGroup.code)
      || userGroup.code.length > globalFieldLengths.code)
  ) {
    return clientError(
      { entity: 'usergroup' },
      intl.formatMessage({ id: 'save.usergroup.validation.code.title' }),
      intl.formatMessage({ id: 'validation.invalid.code' }, { characters: urlDenyCharacters }),
      [fields.CODE],
    );
  }

  return undefined;
};

export const validateUserGroupName = (userGroup, intl) => {
  if (userGroup.name && userGroup.name.length > globalFieldLengths.name) {
    return clientError(
      { entity: 'usergroup' },
      intl.formatMessage({ id: 'save.usergroup.validation.name.title' }),
      intl.formatMessage({ id: 'validation.max.length' }, { maximum: globalFieldLengths.name }),
      [fields.NAME],
    );
  }

  if (!hasMinimumLength(userGroup.name)) {
    return clientError(
      { entity: 'usergroup' },
      intl.formatMessage({ id: 'save.usergroup.validation.name.title' }),
      intl.formatMessage({ id: 'save.usergroup.validation.required.name' }),
      [fields.NAME],
    );
  }

  return undefined;
};

export const validateUserGroupDescription = (userGroup, intl) => {
  if (
    userGroup.description
    && userGroup.description.length > globalFieldLengths.description
  ) {
    return clientError(
      { entity: 'usergroup' },
      intl.formatMessage({ id: 'save.usergroup.validation.description.title' }),
      intl.formatMessage({ id: 'validation.max.length' }, { maximum: globalFieldLengths.description }),
      [fields.DESCRIPTION],
    );
  }

  return undefined;
};

export const userGroupSourceCodeFromUrl = (url) => (splitUrlArguments(url).at(2));

export const isUserGroupDuplicateUrl = (url) => {
  if (!url) return false;
  const urlParts = splitUrlArguments(url);
  return urlParts[3] === 'usergroup' && isUUID(urlParts[4]);
};

export const sortByID = (a, b) => a.id - b.id;

export const withUserStates = (user) => ({ ...user, ...destroyStates });

export const updateUsergroupUsersMetrics = (draft, { users, code }) => {
  const totalUsers = users.results.length;
  const totalApprovedUsers = users.results.filter(({ approved }) => approved).length;

  const metrics = {
    all_users: totalUsers,
    approved_users: totalApprovedUsers,
    unapproved_users: totalUsers - totalApprovedUsers,
  };

  findAllUserGroups(draft, { items: [{ code }] }).forEach((category) => {
    const item = findResult(draft.userGroups, category, code);
    if (item) { assignProps(item, { metrics }); }
  });
};
